import React from "react";
import { useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import {
  MailIcon,
  LocationMarkerIcon,
  ChevronDownIcon,
  ShoppingCartIcon,
  MenuIcon,
  XIcon,
} from "@heroicons/react/solid";
import { Popover, Transition } from "@headlessui/react";
import ProductNavigation from "./productNavigation";

const ProductLayout = (props) => {
  const data = useStaticQuery(graphql`
    {
      prismicNavigationBar {
        data {
          header_options {
            header_link
            header_name
          }
          facebook_link {
            url
          }
          instagram_link {
            url
          }
          linkedin_link {
            url
          }
          twitter_link {
            url
          }
        }
      }
    }
  `);

  return (
    <>
      {/* Mobile Menu */}
      <Popover className="top-0 duration-200 ease-in-out z-50">
        {({ open }) => (
          <div className="block md:hidden z-50 w-full">
            <div className="flex flex-row items-center justify-between p-4 bg-gray-700">
              {/* Logo */}
              <Link to="/dealers" activeClassName="text-blue-500">
                <LocationMarkerIcon className="h-6 w-6 text-gray-50" />
              </Link>
              <Link to="/">
                <svg
                  className="h-8 w-8 fill-current text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M32 16.0003C32.0062 20.0094 30.5005 23.8734 27.7834 26.8214C27.6321 26.9859 27.4775 27.1488 27.3187 27.3065C27.311 27.3139 27.3026 27.3205 27.2935 27.3261C27.1558 27.4038 26.9965 27.4342 26.8399 27.4126C26.6833 27.3911 26.5381 27.3187 26.4266 27.2067L15.2182 15.9997L21.568 9.63168C21.5778 9.62159 21.5895 9.61354 21.6024 9.60805C21.6153 9.60255 21.6292 9.5997 21.6433 9.59967H25.1084C25.1295 9.59975 25.1501 9.60608 25.1676 9.61785C25.1851 9.62962 25.1988 9.64632 25.2068 9.66582C25.2149 9.68532 25.2169 9.70675 25.2128 9.72744C25.2086 9.74813 25.1985 9.76714 25.1836 9.78207L19.0601 15.9213C19.0502 15.9311 19.0423 15.9429 19.037 15.9558C19.0316 15.9687 19.0289 15.9825 19.0289 15.9965C19.0289 16.0104 19.0316 16.0243 19.037 16.0372C19.0423 16.0501 19.0502 16.0618 19.0601 16.0717L26.7123 23.7242C26.7232 23.7352 26.7365 23.7437 26.7511 23.7491C26.7657 23.7545 26.7813 23.7567 26.7968 23.7554C26.8123 23.7542 26.8273 23.7496 26.8409 23.7419C26.8544 23.7342 26.8661 23.7237 26.8752 23.711C28.7402 21.0808 29.5889 17.8638 29.2639 14.6559C28.9389 11.448 27.4624 8.46651 25.1077 6.26367C25.0973 6.25406 25.0889 6.24244 25.0831 6.22949C25.0772 6.21655 25.074 6.20256 25.0737 6.18836C25.0734 6.17416 25.076 6.16003 25.0813 6.14685C25.0866 6.13368 25.0945 6.12172 25.1045 6.11168L26.8394 4.376C26.8591 4.35618 26.8857 4.34481 26.9137 4.34434C26.9417 4.34386 26.9687 4.35431 26.9891 4.37344C28.5732 5.86695 29.8348 7.66887 30.6963 9.66828C31.5578 11.6677 32.0009 13.8223 31.9983 15.9994L32 16.0003Z"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22.9319 27.4848L24.7128 29.2656C24.7241 29.2769 24.7328 29.2906 24.7381 29.3057C24.7435 29.3208 24.7454 29.3368 24.7437 29.3528C24.7421 29.3687 24.7369 29.384 24.7286 29.3977C24.7202 29.4113 24.7089 29.4229 24.6955 29.4317C22.2797 30.9954 19.4869 31.8786 16.6112 31.9884C13.7355 32.0981 10.8834 31.4304 8.35544 30.0554C5.82742 28.6804 3.71704 26.6492 2.24657 24.1756C0.776108 21.702 0 18.8776 0 16C0 13.1224 0.776108 10.298 2.24657 7.82443C3.71704 5.35083 5.82742 3.31957 8.35544 1.94461C10.8834 0.569649 13.7355 -0.0981193 16.6112 0.0116468C19.4869 0.121413 22.2797 1.00465 24.6955 2.56832C24.7089 2.57706 24.7202 2.58868 24.7286 2.60234C24.7369 2.61599 24.7421 2.63133 24.7437 2.64725C24.7454 2.66316 24.7435 2.67924 24.7381 2.69432C24.7328 2.7094 24.7241 2.72309 24.7128 2.7344L11.5214 15.9245C11.5115 15.9343 11.5037 15.9461 11.4983 15.959C11.493 15.9719 11.4902 15.9857 11.4902 15.9997C11.4902 16.0137 11.493 16.0275 11.4983 16.0404C11.5037 16.0533 11.5115 16.065 11.5214 16.0749L17.6657 22.2189C17.6806 22.2338 17.6908 22.2528 17.6949 22.2735C17.699 22.2942 17.697 22.3156 17.6889 22.3351C17.6809 22.3546 17.6672 22.3713 17.6497 22.3831C17.6322 22.3949 17.6116 22.4012 17.5905 22.4013H14.0742L7.74969 16.0749C7.7398 16.065 7.73196 16.0533 7.72661 16.0404C7.72125 16.0275 7.7185 16.0137 7.7185 15.9997C7.7185 15.9857 7.72125 15.9719 7.72661 15.959C7.73196 15.9461 7.7398 15.9343 7.74969 15.9245L20.1772 3.49824C20.1901 3.48534 20.1995 3.46936 20.2044 3.45183C20.2094 3.4343 20.2099 3.41579 20.2057 3.39804C20.2015 3.38029 20.1929 3.3639 20.1806 3.35042C20.1684 3.33693 20.1529 3.32679 20.1356 3.32096C18.0157 2.62947 15.7563 2.48054 13.564 2.88782C11.3716 3.29509 9.31645 4.24556 7.5864 5.65227C5.85634 7.05899 4.50666 8.87704 3.66081 10.9401C2.81496 13.0032 2.49996 15.2454 2.74462 17.4616C2.98927 19.6779 3.78578 21.7974 5.06127 23.6263C6.33676 25.4552 8.05052 26.9351 10.0458 27.9307C12.041 28.9262 14.254 29.4055 16.4824 29.3248C18.7108 29.2441 20.8833 28.606 22.8014 27.4688C22.8215 27.4569 22.845 27.4521 22.8682 27.4551C22.8913 27.458 22.9129 27.4686 22.9294 27.4851L22.9319 27.4848Z"
                  />
                </svg>
              </Link>
              <Popover.Button>
                <ChevronDownIcon
                  className={`${
                    open
                      ? "transform rotate-180 h-6 w-6 text-white transition transition-translate"
                      : "h-6 w-6 text-white transition transition-translate"
                  }`}
                />
              </Popover.Button>
            </div>
            <Transition
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <Popover.Panel>
                <div className="w-full absolute bg-gray-700 z-40 shadow py-6">
                  <ul className="flex flex-col mx-8 divide-y divide-gray-500">
                    {data.prismicNavigationBar.data.header_options.map(
                      (item) => (
                        <Link
                          className="text-base font-light text-gray-50 cursor-pointer py-3"
                          to={item.header_link}
                          activeClassName="font-medium text-blue-500"
                        >
                          {item.header_name}
                        </Link>
                      )
                    )}
                  <ul className="flex flex-row space-x-2 py-4 mb-2 items-center">
                    <li className="flex-grow text-gray-200 text-base font-light">
                      Follow us on
                    </li>
                    <li>
                      <a
                        href={data.prismicNavigationBar.data.facebook_link.url}
                        target="_blank"
                      >
                        <svg
                          className="h-6 w-6 fill-current text-gray-200"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <title>Logo Facebook</title>
                          <path
                            d="M480 257.35c0-123.7-100.3-224-224-224s-224 100.3-224 224c0 111.8 81.9 204.47 189 221.29V322.12h-56.89v-64.77H221V208c0-56.13 33.45-87.16 84.61-87.16 24.51 0 50.15 4.38 50.15 4.38v55.13H327.5c-27.81 0-36.51 17.26-36.51 35v42h62.12l-9.92 64.77H291v156.54c107.1-16.81 189-109.48 189-221.31z"
                            fill-rule="evenodd"
                          />
                        </svg>
                      </a>
                    </li>

                    <li>
                      <a
                        href={data.prismicNavigationBar.data.instagram_link.url}
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 fill-current text-gray-200"
                          viewBox="0 0 512 512"
                        >
                          <title>Logo Instagram</title>
                          <path d="M349.33 69.33a93.62 93.62 0 0193.34 93.34v186.66a93.62 93.62 0 01-93.34 93.34H162.67a93.62 93.62 0 01-93.34-93.34V162.67a93.62 93.62 0 0193.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z" />
                          <path d="M377.33 162.67a28 28 0 1128-28 27.94 27.94 0 01-28 28zM256 181.33A74.67 74.67 0 11181.33 256 74.75 74.75 0 01256 181.33m0-37.33a112 112 0 10112 112 112 112 0 00-112-112z" />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a
                        href={data.prismicNavigationBar.data.twitter_link.url}
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 fill-current text-gray-200"
                          viewBox="0 0 512 512"
                        >
                          <title>Logo Twitter</title>
                          <path d="M496 109.5a201.8 201.8 0 01-56.55 15.3 97.51 97.51 0 0043.33-53.6 197.74 197.74 0 01-62.56 23.5A99.14 99.14 0 00348.31 64c-54.42 0-98.46 43.4-98.46 96.9a93.21 93.21 0 002.54 22.1 280.7 280.7 0 01-203-101.3A95.69 95.69 0 0036 130.4c0 33.6 17.53 63.3 44 80.7A97.5 97.5 0 0135.22 199v1.2c0 47 34 86.1 79 95a100.76 100.76 0 01-25.94 3.4 94.38 94.38 0 01-18.51-1.8c12.51 38.5 48.92 66.5 92.05 67.3A199.59 199.59 0 0139.5 405.6a203 203 0 01-23.5-1.4A278.68 278.68 0 00166.74 448c181.36 0 280.44-147.7 280.44-275.8 0-4.2-.11-8.4-.31-12.5A198.48 198.48 0 00496 109.5z" />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a
                        href={data.prismicNavigationBar.data.linkedin_link.url}
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 fill-current text-gray-200"
                          viewBox="0 0 512 512"
                        >
                          <title>Logo Linkedin</title>
                          <path d="M444.17 32H70.28C49.85 32 32 46.7 32 66.89v374.72C32 461.91 49.85 480 70.28 480h373.78c20.54 0 35.94-18.21 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zm-273.3 373.43h-64.18V205.88h64.18zM141 175.54h-.46c-20.54 0-33.84-15.29-33.84-34.43 0-19.49 13.65-34.42 34.65-34.42s33.85 14.82 34.31 34.42c-.01 19.14-13.31 34.43-34.66 34.43zm264.43 229.89h-64.18V296.32c0-26.14-9.34-44-32.56-44-17.74 0-28.24 12-32.91 23.69-1.75 4.2-2.22 9.92-2.22 15.76v113.66h-64.18V205.88h64.18v27.77c9.34-13.3 23.93-32.44 57.88-32.44 42.13 0 74 27.77 74 87.64z" />
                        </svg>
                      </a>
                    </li>
                  </ul>
                  </ul>
                  
                </div>
              </Popover.Panel>
            </Transition>
          </div>
        )}
      </Popover>

      {/* Desktop Menu */}
      <nav className="hidden md:block w-full top-0 z-50 bg-gray-700 h-20 py-5 px-10 shadow">
        {/* Logo */}
        <div className="max-w-screen-lg md:flex flex-row justify-between items-center mx-auto">
          <div>
            <Link to="/">
              <svg
                className="h-10 w-10 fill-current text-white hover:text-blue-500"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M32 16.0003C32.0062 20.0094 30.5005 23.8734 27.7834 26.8214C27.6321 26.9859 27.4775 27.1488 27.3187 27.3065C27.311 27.3139 27.3026 27.3205 27.2935 27.3261C27.1558 27.4038 26.9965 27.4342 26.8399 27.4126C26.6833 27.3911 26.5381 27.3187 26.4266 27.2067L15.2182 15.9997L21.568 9.63168C21.5778 9.62159 21.5895 9.61354 21.6024 9.60805C21.6153 9.60255 21.6292 9.5997 21.6433 9.59967H25.1084C25.1295 9.59975 25.1501 9.60608 25.1676 9.61785C25.1851 9.62962 25.1988 9.64632 25.2068 9.66582C25.2149 9.68532 25.2169 9.70675 25.2128 9.72744C25.2086 9.74813 25.1985 9.76714 25.1836 9.78207L19.0601 15.9213C19.0502 15.9311 19.0423 15.9429 19.037 15.9558C19.0316 15.9687 19.0289 15.9825 19.0289 15.9965C19.0289 16.0104 19.0316 16.0243 19.037 16.0372C19.0423 16.0501 19.0502 16.0618 19.0601 16.0717L26.7123 23.7242C26.7232 23.7352 26.7365 23.7437 26.7511 23.7491C26.7657 23.7545 26.7813 23.7567 26.7968 23.7554C26.8123 23.7542 26.8273 23.7496 26.8409 23.7419C26.8544 23.7342 26.8661 23.7237 26.8752 23.711C28.7402 21.0808 29.5889 17.8638 29.2639 14.6559C28.9389 11.448 27.4624 8.46651 25.1077 6.26367C25.0973 6.25406 25.0889 6.24244 25.0831 6.22949C25.0772 6.21655 25.074 6.20256 25.0737 6.18836C25.0734 6.17416 25.076 6.16003 25.0813 6.14685C25.0866 6.13368 25.0945 6.12172 25.1045 6.11168L26.8394 4.376C26.8591 4.35618 26.8857 4.34481 26.9137 4.34434C26.9417 4.34386 26.9687 4.35431 26.9891 4.37344C28.5732 5.86695 29.8348 7.66887 30.6963 9.66828C31.5578 11.6677 32.0009 13.8223 31.9983 15.9994L32 16.0003Z"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.9319 27.4848L24.7128 29.2656C24.7241 29.2769 24.7328 29.2906 24.7381 29.3057C24.7435 29.3208 24.7454 29.3368 24.7437 29.3528C24.7421 29.3687 24.7369 29.384 24.7286 29.3977C24.7202 29.4113 24.7089 29.4229 24.6955 29.4317C22.2797 30.9954 19.4869 31.8786 16.6112 31.9884C13.7355 32.0981 10.8834 31.4304 8.35544 30.0554C5.82742 28.6804 3.71704 26.6492 2.24657 24.1756C0.776108 21.702 0 18.8776 0 16C0 13.1224 0.776108 10.298 2.24657 7.82443C3.71704 5.35083 5.82742 3.31957 8.35544 1.94461C10.8834 0.569649 13.7355 -0.0981193 16.6112 0.0116468C19.4869 0.121413 22.2797 1.00465 24.6955 2.56832C24.7089 2.57706 24.7202 2.58868 24.7286 2.60234C24.7369 2.61599 24.7421 2.63133 24.7437 2.64725C24.7454 2.66316 24.7435 2.67924 24.7381 2.69432C24.7328 2.7094 24.7241 2.72309 24.7128 2.7344L11.5214 15.9245C11.5115 15.9343 11.5037 15.9461 11.4983 15.959C11.493 15.9719 11.4902 15.9857 11.4902 15.9997C11.4902 16.0137 11.493 16.0275 11.4983 16.0404C11.5037 16.0533 11.5115 16.065 11.5214 16.0749L17.6657 22.2189C17.6806 22.2338 17.6908 22.2528 17.6949 22.2735C17.699 22.2942 17.697 22.3156 17.6889 22.3351C17.6809 22.3546 17.6672 22.3713 17.6497 22.3831C17.6322 22.3949 17.6116 22.4012 17.5905 22.4013H14.0742L7.74969 16.0749C7.7398 16.065 7.73196 16.0533 7.72661 16.0404C7.72125 16.0275 7.7185 16.0137 7.7185 15.9997C7.7185 15.9857 7.72125 15.9719 7.72661 15.959C7.73196 15.9461 7.7398 15.9343 7.74969 15.9245L20.1772 3.49824C20.1901 3.48534 20.1995 3.46936 20.2044 3.45183C20.2094 3.4343 20.2099 3.41579 20.2057 3.39804C20.2015 3.38029 20.1929 3.3639 20.1806 3.35042C20.1684 3.33693 20.1529 3.32679 20.1356 3.32096C18.0157 2.62947 15.7563 2.48054 13.564 2.88782C11.3716 3.29509 9.31645 4.24556 7.5864 5.65227C5.85634 7.05899 4.50666 8.87704 3.66081 10.9401C2.81496 13.0032 2.49996 15.2454 2.74462 17.4616C2.98927 19.6779 3.78578 21.7974 5.06127 23.6263C6.33676 25.4552 8.05052 26.9351 10.0458 27.9307C12.041 28.9262 14.254 29.4055 16.4824 29.3248C18.7108 29.2441 20.8833 28.606 22.8014 27.4688C22.8215 27.4569 22.845 27.4521 22.8682 27.4551C22.8913 27.458 22.9129 27.4686 22.9294 27.4851L22.9319 27.4848Z"
                />
              </svg>
            </Link>
          </div>
          {/* Main Navigation */}
          <ul className="flex flex-row space-x-6 items-center">
            {data.prismicNavigationBar.data.header_options.map((item) => (
              <Link
                className="text-base font-regular hover:font-medium active:text-blue-500 active:font-medium text-white hover:text-blue-500 cursor-pointer"
                to={item.header_link}
                activeClassName="text-blue-500 font-medium"
              >
                {item.header_name}
              </Link>
            ))}
          </ul>
          {/* Side Logos */}
          <ul className="flex flex-row space-x-5 items-center">
            <Link to = "/contact-us">
              <li>
                <MailIcon className="h-6 w-6 text-white hover:text-blue-600" />
              </li>
            </Link>
            <Link to = "/dealers/">
              <li>
                <LocationMarkerIcon className="h-6 w-6 text-white hover:text-blue-600" />
              </li>
            </Link >
            <Link to = "/coming-soon/">
              <li>
                <ShoppingCartIcon className="h-6 w-6 text-white hover:text-blue-600" />
              </li>
            </Link>
          </ul>
        </div>
      </nav>
     

      {props.children}
    </>
  );
};

export default ProductLayout;
